// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__bOA2r","list":"Navbar_list__WVyB5","current":"Navbar_current__Kuu56","logo":"Navbar_logo__y4Czz","hiddenformobile":"Navbar_hiddenformobile__ikKWu"};